import { api } from '@/helpers/interceptors'
import {
  GET_BU,
  GET_STORE,
  GET_CATEGORY,
  GET_CATEGORIES,
} from '@/constants/path'

const state = () => ({
  bu: null,
  store: null,
  category: null,
  categories: [], // All Category
  isError: false,
  isLoading: false,
})

// getters
const getters = {}

// actions
const actions = {
  async getBu({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    try {
      let res
      if (!payload?.buId) {
        res = await api(GET_BU, 'get')
      } else {
        res = await api(`${GET_BU}?bu_id=${payload?.buId}`, 'get')
      }
      commit('SET_BU', [
        {
          bu_id: 'all',
          bu_name: 'All BU',
        },
        ...res?.data?.data,
      ])
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_BU', null)
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async getStore({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    try {
      let res
      if (!payload?.storeId) {
        res = await api(GET_STORE, 'get')
      } else {
        res = await api(
          `${GET_STORE}?store_id=${payload?.storeId}`,
          'get',
        )
      }
      commit('SET_STORE', [
        // {
        //   bu_id: 'all',
        //   bu_name: 'All Store',
        // },
        ...res?.data?.data,
      ])
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_STORE', null)
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async getCategory({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    try {
      let res
      if (payload?.storeId) {
        res = await api(
          `${GET_CATEGORY}?store_id=${payload?.storeId}`,
          'get',
        )
      } else {
        if (!payload?.buId) {
          res = await api(GET_CATEGORY, 'get')
        } else {
          res = await api(
            `${GET_CATEGORY}?bu_id=${payload?.buId}`,
            'get',
          )
        }
      }

      commit('SET_CATEGORY', res?.data?.data)
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_CATEGORY', null)
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async getCategories({ commit }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    try {
      const res = await api(GET_CATEGORIES, 'get')
      commit('SET_CATEGORIES', res?.data?.data)
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_CATEGORIES', [])
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
}

// mutations
const mutations = {
  SET_ERROR(state, payload) {
    state.isError = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
  SET_BU(state, payload) {
    state.bu = payload
  },
  SET_STORE(state, payload) {
    state.store = payload
  },
  SET_CATEGORY(state, payload) {
    state.category = payload
  },
  SET_CATEGORIES(state, payload) {
    state.categories = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
